const config = {
  env: process.env.REACT_APP_NODE_ENV,
  baseURL: process.env.REACT_APP_API_URL,
  recaptchaKey: process.env.REACT_APP_RECAPTCHA_KEY,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASURMENT_ID,
  vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
  captchaDisabled: JSON.parse(process.env.REACT_APP_CAPTCHA_DISABLED ?? 'false'),
  availabilityDeadline: Number(process.env.REACT_APP_AVAILABILITY_DEADLINE),
  googleMapsUrl: process.env.REACT_APP_GOOGLE_MAPS_URL,
}

export { config }
